/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aml_In_Reason_From_SupplierInputs */

const vi_aml_in_reason_from_supplier = /** @type {(inputs: Aml_In_Reason_From_SupplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mua từ NCC`)
};

/**

* @param {Aml_In_Reason_From_SupplierInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aml_in_reason_from_supplier = /** @type {((inputs?: Aml_In_Reason_From_SupplierInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aml_In_Reason_From_SupplierInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aml_in_reason_from_supplier(inputs)
});